export const filterSidebarList = {
  data() {
    return {
      nameList: [],
      filter: {
        nameSelected: []
      },
      filterMap: {}
    }
  },
  computed: {
    nameSelected() {
      return this.filter.nameSelected
    }
  },
  methods: {
    mapFilter(_filterItem, _key) {
      this.filterMap[_key] = []
      _filterItem.forEach(item => {
        this.filterMap[_key].push(item['id'])
      })
      if (!this.filterMap[_key].length) {
        delete this.filterMap[_key]
      }
    },
    resetCondition() {
      Object.keys(this.filter).forEach(key => {
        this.filter[key] = []
      })
      this.nameList = []
    },
    addTag (newTag) {
      const tag = {
        name: newTag,
        id: newTag
      }
      this.nameList.push(tag)
      this.filter.nameSelected.push(tag)
    }
  },
  watch: {
    nameSelected(value) {
      this.mapFilter(value, 'names')
    }
  }
}
